import {Card} from "../../@types/buildingOnlineAdvantagesCardsResources.tsx";
import advantageIcon1 from '/assets/images/accelerating-online-page-images/advantage-icon-1.svg';
import advantageIcon2 from '/assets/images/accelerating-online-page-images/advantage-icon-2.svg';
import advantageIcon3 from '/assets/images/accelerating-online-page-images/advantage-icon-3.svg';

export const AcceleratingOnlineAdvantagesCardsConfig: Card[] = [
    {
        image: advantageIcon1,
        description: 'accelerating_online_advantage_1'
    },
    {
        image: advantageIcon2,
        description: 'accelerating_online_advantage_2'
    },
    {
        image: advantageIcon3,
        description: 'accelerating_online_advantage_3'
    }
]
